import PropTypes from 'prop-types'
import React from 'react'
import OrderActionsHelp from './OrderActions.Help'
import OrderActionsTitle from './OrderActions.Title'
import './index.scss'
import ContentBox from 'components/ContentBox'

class OrderActions extends React.Component {
  static Help = OrderActionsHelp

  static Title = OrderActionsTitle

  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired
  }

  render () {
    return (
      <ContentBox className='orderActions'>
        {this.props.children}
      </ContentBox>
    )
  }
}

export default OrderActions
